import React from 'react';
import RoleRow from './rolerow';

function RoleList(props) {
	return (
		<section id="tablebodycontainer" className="customScrollbar userlist-body">
			<section className="userlistholder">
				{props.list.map((item, index) => (
					<RoleRow
						key={index + item}
						data={item}
						onDeleteClick={props.onDeleteClick}
					/>
				))}
			</section>
		</section>
	);
}

export default RoleList;
